import React from 'react';
import styled from 'styled-components';
import { Link } from 'react-router-dom';
import Title from 'components/text/Title';
import Icon from 'components/common/Icon';
import Caption from 'components/text/Caption';

const Container = styled.div`
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
`;

const Content = styled.div`
  height: 288px;
  width: 350px;
  padding: 8px;
  border: 1px solid #efefef;
  text-align: center;
  display: flex;
  align-items: center;
  justify-content: center;
`;

const UnsubscribedContent = () => (
  <Container>
    <Content>
      <div>
        <Icon style={{ fontSize: 80, marginBottom: 15 }} type="frown" theme="twoTone" />
        <Title>Your subscription is off</Title>
        <Caption style={{ color: '#999' }}>
          If this is incorrect, or you'd like to renew your subscription, please reach out to us{' '}
          <Link to="/contact">here</Link>.
        </Caption>
      </div>
    </Content>
  </Container>
);

export default UnsubscribedContent;



// WEBPACK FOOTER //
// ./src/components/common/UnsubscribedContent/index.js